// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__271rf","inputWrap":"Table_inputWrap__E0So5","col":"Table_col__1MO2g","bmiTooltip":"Table_bmiTooltip__3I2hM"};